import AuctionChart from '../auctionChart';
import PrepaymentChart from '../prepaymentChart';
import SaleChart from '../saleChart';
import SimpleChart from '../simpleChart';
interface SimpleChartProps {
  guid: string;
  app: 'farm' | 'wholesaler';
}
export const chartSwitcher: Record<
  string,
  (post: SimpleChartProps) => JSX.Element
> = {
  simple: props => {
    return <SimpleChart app={props.app} guid={props.guid} />;
  },
  sale: props => {
    return <SaleChart app={props.app} guid={props.guid} />;
  },
  prepayment: props => {
    return <PrepaymentChart app={props.app} guid={props.guid} />;
  },
  auction: props => {
    return <AuctionChart app={props.app} guid={props.guid} />;
  },
};
